$(function() {
  var $animation_elements = $('.rx-animated');
  var $window = $(window);

  function onsight() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = (element_top_position + element_height);

      //check to see if this current container is within viewport
      if ((element_bottom_position >= window_top_position) &&
          (element_top_position <= window_bottom_position)) {
        $element.addClass('onsight');
        $element.remove("rx-animated");
      }
    });
  }

  $window.on('load scroll resize', onsight);
  $window.trigger('load scroll resize');
});

var productImageObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate');
    }
  });
});
let target = '.product__media-item';
document.querySelectorAll(target).forEach((i) => {
    if (i) {
      productImageObserver.observe(i);
    }
});
// productImageObserver.observe(document.querySelector('.product__media-item'));